import React from "react";
import { Flex, Text } from "styles/utility-components";

import { currencyFormat, numberFormatLong } from "components/app_layout/Typography/Numbers";
import SkeletonText from "components/ui/skeleton/SkeletonText";

type HeadlineFigureProps = {
  label: string;
  value: number | undefined | null;
  isLoading: boolean;
  valueType: "number" | "currency";
  noPluralise?: boolean;
};

const HeadlineFigure = ({
  label,
  value,
  isLoading,
  valueType,
  noPluralise = false,
}: HeadlineFigureProps) => {
  const toPluralise = noPluralise === false && value !== 1;
  return (
    <Flex gap={8} alignItems="baseline">
      {isLoading ? (
        <SkeletonText width="80px" fontSize={24} />
      ) : (
        <Text h1>
          {valueType === "number"
            ? numberFormatLong(value ?? null)
            : currencyFormat(value ?? null, "GBP")}
        </Text>
      )}
      <Text>{toPluralise ? `${label}s` : label}</Text>
    </Flex>
  );
};

export default HeadlineFigure;
